<template lang="pug">
.team(
  :style="{height: height}")
  b-header
    .sub_nav(v-show="currentPage !== 0 && Math.abs(scrollTop) < 100")
      //- ul.mobi
      //-   li(:class="{current: currentPage === 1}" @click="turnTo(1)") {{langs[lang].iteam}}
      //-   li(:class="{current: currentPage === 2}" @click="turnTo(2)") {{langs[lang].piteam}}
  .container(
    ref="fullpage",
    v-fullpage="opts",
    @mousewheel="mousewheel"
    @wheel="mousewheel")
    .page.pc(
      v-if="!isMobi",
      style="overflow:hidden")
      .nav
        transition(name="left-in")
          .line(v-show="init")
        transition(name="right-in")
          .title(v-show="init") {{langs[lang].title}}
        transition(name="bottom-in-delay")
          ul(v-show="init")
            li(@click="turnTo(1)") {{langs[lang].iteam}}
            li(@click="turnTo(1, 2)") {{langs[lang].piteam}}
      .movie
        video(
          :src="isMobi? require('../assets/team_mobi.mp4') : require('../assets/team.mp4')",
          @mouseenter="movieEnter",
          @mouseleave="movieLeave",
          autoplay
          loop
          style="width:100%")
    .page(
      :style="{overflowY: 'scroll'}"
      @mousewheel.stop="sub_mousewheel_iteam",
      ref='iteam'
      )
      .nav.mobi
        transition(name="left-in")
          .line(v-show="init")
        transition(name="right-in")
          .title(v-show="init") {{langs[lang].title}}
        transition(name="bottom-in-delay")
          ul(v-show="init")
            li(@click="turnTo(0)") {{langs[lang].iteam}}
            li(@click="turnTo(1, 2)") {{langs[lang].piteam}}
      .photo.mobi
        img(src="../assets/team/total.jpg")
      .sub_title
        transition(name="left-in")
          span(v-show="animateCtrl[1 - !!isMobi]") {{langs[lang].iteam}}
      .peoples
        .people(
          v-for="(item, index) in iteamList",
          @mouseenter="hover(index)",
          @mouseleave="leave",
          @click.stop="slideDownA(index)")
          img.avatar(
            :src="item.avatar")
          transition(name="bottom-in")
            .text(
              @mousemove="hover(index)",
              @mouseleave="leave",
              v-show="animateCtrl[1 - !!isMobi]")
              .job-title {{item.jobTitle}}
              .name {{item.title}}
          transition(
            appear,
            @before-enter="beforeEnter",
            @enter="enter",
            @leave="leaves")
            .descs(
              v-show="openIndexA == index")
              .desc
                .introduction {{langs[lang].introduction}}:
                .content(v-html="item.content")
                .contact
                  .email {{item.email}}
                  .wechat {{item.wechat}}
              .close(@click.stop="close")
                span.iconfont &#xe605;
                | close
      .sub_title
        transition(name="left-in")
          span(v-show="animateCtrl[1 - !!isMobi]") {{langs[lang].piteam}}
      .peoples
        .people(
          v-for="(item, index) in piteamList",
          @mousemove="hover(index)",
          @click.stop="slideDownB(index)"
          @mouseleave="leave")
          img.avatar(
            :src="item.avatar")
          transition(name="bottom-in")
            .text(
              @mousemove="hover(index)",
              @mouseleave="leave",
              v-show="animateCtrl[1 - !!isMobi]")
              .job-title {{item.jobTitle}}
              .name {{item.title}}
          transition(
            appear,
            @before-enter="beforeEnter",
            @enter="enter",
            @leave="leaves")
            .descs(
              v-show="openIndexB == index")
              .desc
                .introduction {{langs[lang].introduction}}:
                .content(v-html="item.content")
                .contact
                  .email {{item.email}}
                  .wechat {{item.wechat}}
              .close(@click.stop="close")
                span.iconfont &#xe605;
                | close
</template>

<script>
import _ from 'lodash'
import header from './header'
import fanpage from '../mixin/fanpage.js'

const Team = {
  mixins: [fanpage],
  props: [],
  data () {
    return {
      totalPage: 1,
      hoverIndex: -1,
      openIndexA: -1,
      openIndexB: -1,
      iteamList: [],
      piteamList: [],
      scrollTop: 0,
      langs: {
        en: {
          title: 'OUR TEAM',
          iteam: 'INVESTMENT TEAM',
          piteam: 'POST-INVESTMENT MANAGEMENT TEAM',
          introduction: 'INTRODUCTION'
        },
        zh: {
          title: '我们的团队',
          iteam: '投资团队',
          piteam: '投后管理团队',
          introduction: '简介'
        }
      }
    }
  },
  mounted () {
    let list = []
    this.totalPage = 1
    this.animateCtrl[0] = 1
    window.$http.get(window.hostName + 'wp-json/wp/v2/team?per_page=100').then(res => {
      list = res.data.map(item => {
        return {
          id: item.id,
          title: item.title.rendered,
          content: item.content.rendered,
          avatar: item.avatar.guid,
          link: item.link,
          email: item.email,
          categories: item.categories[0],
          jobTitle: item['job-title'],
          wechat: item.wechat
        }
      }).filter((item) => {
        if (this.lang === 'zh') {
          return /[\u4e00-\u9fa5]/.test(item.title) || /[\u4e00-\u9fa5]/.test(item.content)
        } else {
          return !/[\u4e00-\u9fa5]/.test(item.title) && !/[\u4e00-\u9fa5]/.test(item.content)
        }
      })
      this.iteamList = _.filter(list, {categories: 12})
      this.piteamList = _.filter(list, {categories: 14})
      this.$nextTick(function () {
        window.addEventListener('scroll', this.onScroll, true)
      })
    })
  },
  components: {
    bHeader: header
  },
  computed: {
    isMobi () {
      return window.isMobi
    },
    lang () {
      return localStorage.lang
    }
  },
  methods: {
    slideDownA (index) {
      if (this.openIndexA === index) {
        this.openIndexA = -1
      } else {
        this.openIndexA = index
      }
    },
    slideDownB (index) {
      if (this.openIndexB === index) {
        this.openIndexB = -1
      } else {
        this.openIndexB = index
      }
    },
    close () {
      this.openIndexA = -1
      this.openIndexB = -1
    },
    hover (index) {
      this.hoverIndex = index
    },
    leave () {
      this.hoverIndex = -1
    },
    sub_mousewheel_iteam (e) {
      let top = this.$refs.iteam.scrollTop
      if (top <= 0 && e.deltaY < 0 || top >= this.$refs.iteam.scrollHeight - this.$refs.iteam.clientHeight && e.deltaY > 0) {
        this.mousewheel(e)
      }
    },
    // sub_mousewheel_ipteam (e) {
    //   let top = this.$refs.ipteam.scrollTop
    //   if (top <= 0 && e.deltaY < 0 || top >= this.$refs.ipteam.scrollHeight - this.$refs.ipteam.clientHeight && e.deltaY > 0) {
    //     this.mousewheel(e)
    //   }
    // },
    onScroll () {
      if (this.currentPage === 1) {
        this.scrollTop = this.$refs.iteam.scrollTop
      } else if (this.currentPage === 2) {
        this.scrollTop = this.$refs.ipteam.scrollTop
      }
    },
    beforeEnter: function (el) {
      el.style.display = 'block'
    },
    enter: function (el, done) {
      var clone = el.cloneNode(true)
      el.appendChild(clone)
      let h = clone.clientHeight
      clone.remove()
      let iteamHeight = this.$refs['iteam'].scrollTop
      let ipteamHeight = this.$refs['ipteam'].scrollTop
      window.Velocity.hook(el, 'height', 0)
      window.Velocity(
        el,
        {
          height: h
        },
        {
          duration: 500,
          progress: (progress) => {
            this.$refs['iteam'].scrollTop = iteamHeight + progress[0].clientHeight + 50
            this.$refs['ipteam'].scrollTop = ipteamHeight + progress[0].clientHeight + 50
          },
          complete: () => {
            done()
          }
        }
      )
    },
    leaves: function (el, done) {
      window.Velocity(
        el,
        {
          height: 0
        },
        {
          duration: 500,
          complete: () => {
            el.style.removeProperty('height')
            done()
          }
        }
      )
    },
    movieEnter (e) {
      e.target.play()
    },
    movieLeave (e) {
      e.target.pause()
    }
  }
}
export default Team
</script>

<style lang="stylus">
@media (min-width: 720px) {
  .peoples .people .desc .content p{
    margin: 0;
  }
}
</style>
<style scoped lang="stylus">
@import '../common.styl'
.nav{
  position: absolute;
  z-index: 99;
}
.movie{
  height: calc(100% - 300px);
  margin-top: 300px;
  overflow: hidden;
  video{
    width: 100%;
    position: relative;
    top: -240px;
    z-index: 1;
    display: block;
  }
}
.photo{
  margin-top: 150px;/*no*/
  overflow: hidden;
  img{
    width: 100%;
    position: relative;
    z-index: 1;
    display: block;
  }
}
.page{
  overflow: scroll;
}
@media (min-width: 720px) {
  .page{
    position: relative;
    overflow: auto;
  }
  .sub_nav ul{
    position: absolute;
    z-index: 9999;
    height: 180px;
    width: 920px;
    display: flex;
    justify-content: space-around;
    margin: 0 0 0 500px;
    padding-top: 80px;
    cursor: pointer;
    li{
      float: left;
      text-align: center;
      font-size: 14px;/*no*/
      &.current,
      &:hover{
        color: #002b69;
        font-weight: bold;
        border-bottom: 1px solid #002b69;
      }
    }
  }
  .sub_title{
    margin-top: 180px;
    margin-left: 0;
    width: 100%;
    height: 300px;
    background: url("../assets/bg_blue.png") center / cover;
    span{
      font-size: 56px;
      line-height: 300px;
      display: inline-block;
      color: #fff;
      width: 100%;
      text-align: center;
    }
  }
  .peoples{
    .people{
      position: relative;
      width: 100%;
      overflow: hidden;
      .avatar{
        width: 100%;
        height: 625px;
        cursor: pointer;
        vertical-align: bottom;
        transition: all .5s;
        filter: grayscale(100%);
        &:hover{
          filter: grayscale(0);
        }
      }
      .descs{
        overflow: hidden;
      }
      .desc{
        font-size: 18px;
        padding: 50px 310px;
        .introduction{
          font-weight: bold;
          font-size: 24px;
          margin-bottom: 20px;
        }
        .content{
          column-count: 2;
          column-gap: 100px;
          font-size: 24px;
          color: #666;
          p{
            margin-top: 0;
          }
        }
        .contact{
          font-weight: bold;
          font-size: 24px;
          margin-top: 20px;
        }
      }
      .text{
        position: absolute;
        top: 230px;
        left: 300px;
        color: #002869;
        .job-title{
          font-size: 33px;
          margin-bottom: 10px;
        }
        .name{
          font-weight: bold;
          font-size: 84px;
        }
      }
      .close{
        cursor: pointer;
        text-align: center;
        font-size: 56px;
        border-top: 1px solid #000;
        span{
          color: #e50027;
          font-size: 42px;
          display: inline-block;
          &:hover{
            transition: all .5s;
            transform: rotate(90deg);
          }
        }
      }
    }
  }
  .slide-enter-active, .slide-leave-active {
    transition: all .3s ease;
  }
  .slide-enter, .slide-leave-to {
    max-height: 0;
    opacity: 0;
  }
}
@media (max-width: 720px) {
  .sub_title{
    margin-left: 0;
    width: 100%;
    height: 300px;
    background: url("../assets/bg_blue.png") center / cover;
    span{
      font-size: 56px;
      line-height: 300px;
      display: inline-block;
      color: #fff;
      width: 100%;
      text-align: center;
    }
  }
  .peoples{
    // margin-top: 100px;/*no*/
    .people{
      position: relative;
      width: 100%;
      overflow: hidden;
      .avatar{
        width: 100%;
        height: 625px;
        cursor: pointer;
        vertical-align: bottom;
      }
      .descs{
        overflow: hidden;
      }
      .desc{
        font-size: 18px;
        padding: 50px 200px;
        .introduction{
          font-weight: bold;
          font-size: 16px;/*no*/
          margin-bottom: 20px;
        }
        .content{
          font-size: 14px;/*no*/
          color: #666;
        }
        .contact{
          font-weight: bold;
          font-size: 14px;/*no*/
          margin-top: 20px;
        }
      }
      .text{
        position: absolute;
        top: 130px;
        left: 300px;
        color: #002869;
        .job-title{
          font-size: 14px;/*no*/
          font-weight: lighter;
          margin-bottom: 20px;
        }
        .name{
          font-weight: bold;
          font-size: 20px;/*no*/
        }
      }
      .close{
        cursor: pointer;
        text-align: center;
        font-size: 14px;/*no*/
        padding: 20px 0;
        height: 120px;
        border-top: 1px solid #000;
        span{
          color: #e50027;
          font-size: 12px;/*no*/
          display: inline-block;
          transition: all .5s;
          &:hover{
            transform: rotate(90deg);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// team.vue?22969b0a